function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { cloneElement, Children, isValidElement } from 'react';
import classNames from './classNames';

function decorateWithProps(component) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      className = _ref.className,
      children = _ref.children,
      otherProps = _objectWithoutProperties(_ref, ["className", "children"]);

  return /*#__PURE__*/cloneElement(component, _objectSpread({
    className: classNames(component.props.className, className),
    children: component.props.children || children
  }, otherProps));
}
/**
 * Does a basic search for a component (max two levels deep) that matches
 * the given predicate function. When a match occurs the provided props will be
 * applied
 * @param {Node} component to decorate with given props if matched
 * @param {Object} props to add to matched component
 * @param {Function} isMatch predicate function to check if the component is a match
 * @returns {Node} component with updated matched component with props
 */


function findAndDecorateWithProps(component) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var isMatch = arguments.length > 2 ? arguments[2] : undefined;

  var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
      _ref2$limitOneChild = _ref2.limitOneChild,
      limitOneChild = _ref2$limitOneChild === void 0 ? false : _ref2$limitOneChild,
      parentClassNames = _ref2.parentClassNames;

  if (!component || ! /*#__PURE__*/isValidElement(component)) return component;
  if (isMatch(component)) return decorateWithProps(component, props);

  var decorate = function decorate(x) {
    return isMatch(x) ? decorateWithProps(x, props) : x;
  };

  var children = Children.toArray(component.props.children);
  var childrenToUse = limitOneChild ? decorate(children[0]) : children.map(decorate);
  return /*#__PURE__*/cloneElement(component, {
    children: childrenToUse,
    className: classNames(component.props.className, parentClassNames)
  });
}

export default findAndDecorateWithProps;